module.exports = __webpack_public_path__ + "img/album15_11.2d6118fc.jpg";